import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var VendorStorefrontIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M21.385 3.798C20.928 2.718 19.825 2 18.589 2H5.411l-.184.005c-1.222.071-2.285.841-2.676 1.958L1.501 7h-.003L1 9a3.5 3.5 0 002 3.163V19l.005.2A4 4 0 007 23h10l.2-.005A4 4 0 0021 19v-6.837A3.5 3.5 0 0023 9l-.5-2h-.002l-1.05-3.037-.063-.165zM19 12.465a3.49 3.49 0 01-2-1.015 3.49 3.49 0 01-2.5 1.05 3.49 3.49 0 01-2.5-1.05 3.49 3.49 0 01-2.5 1.05A3.49 3.49 0 017 11.45a3.491 3.491 0 01-2 1.015V19a2 2 0 001.85 1.994L7 21h1.75v-5c0-1.105.97-2 2.167-2h2.166c1.197 0 2.167.895 2.167 2v5H17a2 2 0 001.994-1.85L19 19v-6.535zM4.5 10.5A1.5 1.5 0 013 9h3a1.5 1.5 0 01-1.5 1.5zm5 0A1.5 1.5 0 018 9h3a1.5 1.5 0 01-1.5 1.5zm5 0A1.5 1.5 0 0113 9h3a1.5 1.5 0 01-1.5 1.5zm5 0A1.5 1.5 0 0118 9h3a1.5 1.5 0 01-1.5 1.5zm.894-3.5l-.852-2.432a.995.995 0 00-.836-.648l-.117-.006H5.411a1.01 1.01 0 00-.91.55l-.043.104L3.606 7h16.788zm-7.31 14h-2.167v-5h2.166v5z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
VendorStorefrontIcon.isCarinaIcon = true;
export default VendorStorefrontIcon;
